// src/components/cms/CmsFieldCard.jsx
import React from "react";
import { Card, CardContent, Typography, TextField } from "@mui/material";
import RichHtmlEditor from "./RichHtmlEditor";

export default function CmsFieldCard({ label, type = "text", value, onChange, minRows = 3 }) {
    type = "text";

  return (
    <Card elevation={1} sx={{ height: "100%", borderRadius: 2 }}>
      <CardContent>
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
          {label}
        </Typography>

        {type === "html" ? (
          <RichHtmlEditor value={value || ""} onChange={onChange} minHeight={200} />
        ) : (
          <TextField
            fullWidth
            value={value || ""}
            onChange={(e) => onChange?.(e.target.value)}
            multiline
            minRows={minRows}
          />
        )}
      </CardContent>
    </Card>
  );
}
